import { render, staticRenderFns } from "./SplashScreenReport.vue?vue&type=template&id=bc339eda&scoped=true&lang=pug&"
var script = {}
import style0 from "./SplashScreenReport.vue?vue&type=style&index=0&id=bc339eda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc339eda",
  null
  
)

export default component.exports